<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                      <div class="card-header border-0">
                        <div class="row align-items-center">
                          <div class="col">
                            <h3 class="mb-0">
                              Procedimentos Protéticos
                            </h3>
                          </div>
                        </div>
                      </div>
                       <div class="text-right p-4">
                           <base-button :to="'/procedimentos-proteticos/cadastro'"  class="align-self-start" @click="aplicarFiltros()" :icon="'fas fa-plus'">Novo Procedimento</base-button>
                       </div>
                      <div class="d-flex column px-3 mb-4">
                        <base-button class="align-self-start" :disabled="aplicandoFiltros" :icon="aplicandoFiltros ? 'fas fa-circle-notch fa-spin' : filtrosAlterados ? 'fas fa-check' : 'fas fa-filter'" size="sm" :type="filtrosAlterados ? 'info' : 'default'" :outline="!filtroAberto && !aplicandoFiltros" @click="aplicarFiltros()">{{filtrosAlterados ? 'Aplicar filtros' : 'Filtros'}}</base-button>
                        <div class="row filtros px-2 mt-3" v-show="filtroAberto">

                          <base-input class="mr-2 flex-grow-1" v-if="opcoesFiltros.protetico && user.tipo == 'lab'">
                            <multiselect
                              v-model="filtros.protetico"
                              track-by="valor"
                              label="nomeCompleto"
                              :options="opcoesFiltros.protetico"
                              placeholder="por protético"
                              selectLabel="Selecionar"
                              selectedLabel="✔"
                              deselectLabel="Limpar"
                            >
                              <span slot="noResult">Todos os protéticos</span>
                            </multiselect>
                          </base-input>

                          <base-input class="mr-2 flex-grow-1" type="text" placeholder="buscar descritivo de procedimento" v-model="filtros.nome"></base-input>

                        </div>
                        <base-button size="sm" v-if="filtroAberto" class="limpar mt-2 align-self-end clickable small" outline @click="limparFiltros()">Limpar filtros</base-button>
                      </div>

                      <div class="table-responsive">
                        <template>
                          <base-table class="table align-items-center table-flush"
                                      tbody-classes="list"
                                      :data="procedimentosList">
                            <template slot="columns">
                              <th>ID</th>
                              <th class="text-center">Laboratório</th>
                              <th>Protético</th>
                               <th>Descritivo</th>
                               <th>Valor</th>
                              <th>Data de Criação</th>
                              <th></th>
                            </template>

                            <template slot-scope="{row}">
                              <th scope="row" v-if="!loading2">
                                <span>{{ row.id }}</span>
                              </th>
                              <th scope="row"  class="text-center" v-if="!loading2">
                               {{ row.laboratorio.nomeFantasia }}
                              </th>
                              <td v-if="!loading2">
                                {{ row.protetico.nomeCompleto }}
                              </td>
                               <td v-if="!loading2">
                                {{ row.nome }}
                              </td>
                                <td v-if="!loading2">
                                R$ {{ row.valor.toLocaleString('pt-br', {minimumFractionDigits: 2}) }} 
                              </td>
                              <td v-if="!loading2">
                                <span class="name mb-0 text-sm"> {{formatarData(row.created_at)}}</span>
                              </td>
                              <td class="text-right" v-if="!loading2">
                                  <base-button :to="'/procedimentos-proteticos/cadastro/' + row.id" type="default" icon="far fa-eye" size="sm" title="Visualizar usuário"></base-button>
                                  <base-button @click="removeItem(row.id)" type="danger" icon="fas fa-times" size="sm" class="ml-xs" title="Remover Procedimento"></base-button>
                              </td>

                              <td v-if="loading2">
                                <div class="m-2">
                                  <skeleton altura="5px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                                </div>
                              </td>
                              <td v-if="loading2">
                                <div class="m-2">
                                  <skeleton altura="5px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                                </div>
                              </td>
                               <td v-if="loading2">
                                <div class="m-2">
                                  <skeleton altura="5px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                                </div>
                              </td>
                               <td v-if="loading2">
                                <div class="m-2">
                                  <skeleton altura="5px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                                </div>
                              </td>
                              <td v-if="loading2">
                                <div class="m-2">
                                  <skeleton altura="5px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                                </div>
                              </td>
                              <td v-if="loading2">
                                <div class="m-2">
                                  <skeleton altura="5px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                                </div>
                              </td>
                              <td v-if="loading2">
                                <div class="m-2">
                                  <skeleton altura="5px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                                </div>
                              </td>
                            </template>

                          </base-table>
                        </template>
                      </div>

                       <template v-if="loading">
                          <div class="m-2">
                            <skeleton altura="60px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                          </div>
                        </template>

                       <div class="card-footer d-flex justify-content-center" v-if="!loading">
                        <span class="text-size-xl cursor" @click="loadMore()">
                          <i class="fas fa-chevron-circle-down"></i>
                        </span>
                      </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import procedimentos from '@/cflow/procedimentoProtetico.js'
  //import parametros from "@/cflow/parametros.js";
  import BaseButton from '../../components/BaseButton.vue';
  import BaseInput from '../../components/BaseInput.vue';
  import Multiselect from "vue-multiselect";
  import storage from 'storage';
  import router from '@/router'
  export default {
    name: 'tables',
    components: {
      Multiselect,
      BaseButton,
      BaseInput
    },
    methods: {
      removeItem: function(id) {
        this.loading2 = true;
        Promise.all([procedimentos.excluir(id)]).then(() => {
          this.$notify({
            group: 'geral',
            title: 'Alteração salva',
            text: 'Os dados foram atualizados com sucesso.',
            duration: 2000
          });
          router.go('/procedimentos-proteticos');
        })
      },
      aplicarFiltros() {
        this.filtroAberto = !this.filtroAberto
        if(this.filtrosAlterados){
          // se os filtros mudaram, então aplicar eles.
          this.aplicandoFiltros = true;
          this.loading = true;

          let protetico = 0;
          if(this.filtros?.protetico?.id)
            protetico = this.filtros.protetico.id;

          procedimentos.listar({filtros: this.filtros}, 0,protetico).then(res => {
            this.procedimentosList = res;
            this.aplicandoFiltros = false;
            this.filtrosAlterados = false;
            this.loading = false;
          }).catch(() => {
            this.aplicandoFiltros = false;
          })
        }
      },
      limparFiltros() {
        this.filtros = {
          numero: null,
          data: null,
          status: null,
          dentista: null,
          paciente: null
        }
      },
      loadMore: function() {
        this.skiped = this.skiped + this.procedimentosList.length;
        this.initLoad(this.skiped);
      },
      initLoad: function(skiped) {
        this.loading = true;
        var user = storage.get("user");
        //var labId = 0;
        if(user.tipo && user.tipo == 'lab') {
          //labId = user.id;
        }
        Promise.all([procedimentos.listar([],skiped), procedimentos.listar([],skiped, 0, 1)]).then( res => {
          this.procedimentosList = this.procedimentosList.concat(res[0]);
          this.loading = false;
         
          this.opcoesFiltros.protetico = res[1];
        })
      }
    },
    watch: {
      filtros: {
        deep: true,
        handler(){
          this.filtrosAlterados = true
        }
      }
    },
    data() {
      return {
        loading: false,
        loading2: false,
        skiped: 0,
        user: null,
        procedimentosList:[],
        filtrosAlterados: false,
        filtroAberto: false,
        aplicandoFiltros: false,
        filtros: {
            status: null,
            protetico: null
        },
        opcoesFiltros: {
          protetico: [],
          paciente: [],
        }
      }
    },
    mounted(){
      this.user = storage.get("user");
      this.initLoad(0);
    }
  };
</script>
<style lang="scss" scoped>
.filtros .form-group{
  width: 150px;
}
</style>
